import { LEGAL_INFO } from './legal-info';
import { LegalLayout } from './LegalLayout';

export function CookiesPage() {
  return (
    <LegalLayout
      title="Politique de cookies"
      subtitle={`Utilisation des cookies et traceurs sur le service « ${LEGAL_INFO.productName} ».`}
    >
      <section>
        <h2>1. Qu'est-ce qu'un cookie ?</h2>
        <p>
          Un cookie est un petit fichier déposé sur votre terminal (ordinateur, téléphone, tablette)
          par les sites que vous visitez. Il permet notamment de mémoriser des informations entre
          deux visites, comme votre session d'authentification.
        </p>
      </section>

      <section>
        <h2>2. Cookies utilisés par le Service</h2>
        <p>
          Le service « {LEGAL_INFO.productName} » n'utilise que des cookies{' '}
          <strong>strictement nécessaires</strong> à son fonctionnement. Ces cookies ne nécessitent
          pas de consentement préalable au titre de l'article 82 de la loi Informatique et Libertés
          (recommandation CNIL relative aux cookies et autres traceurs).
        </p>

        <h3>2.1 Cookie de session (refresh token)</h3>
        <ul>
          <li>
            <strong>Nom :</strong> <code>refreshToken</code> (cookie HTTPOnly, Secure,
            SameSite=Strict)
          </li>
          <li>
            <strong>Finalité :</strong> maintenir l'utilisateur authentifié sans avoir à ressaisir
            ses identifiants à chaque action.
          </li>
          <li>
            <strong>Durée de vie :</strong> trente (30) jours maximum.
          </li>
          <li>
            <strong>Émetteur :</strong> {LEGAL_INFO.companyName} (cookie interne, premier party).
          </li>
        </ul>

        <h3>2.2 Stockage local technique</h3>
        <p>
          Le Service utilise également le stockage local du navigateur (mémoire de session) pour
          conserver le jeton d'accès court (« access token ») nécessaire à l'authentification des
          requêtes API. Ce stockage est purgé à la déconnexion ou à la fermeture de la session.
        </p>
      </section>

      <section>
        <h2>3. Absence de cookies tiers</h2>
        <p>
          Le Service <strong>n'utilise pas</strong> :
        </p>
        <ul>
          <li>de cookies de mesure d'audience tiers (Google Analytics, Matomo, etc.) ;</li>
          <li>de cookies publicitaires ou de profilage ;</li>
          <li>de cookies de réseaux sociaux ;</li>
          <li>de pixels ou « beacons » tiers.</li>
        </ul>
        <p>
          Si une telle utilisation devenait nécessaire à l'avenir, une bannière de consentement
          serait mise en place préalablement, conformément aux recommandations de la CNIL.
        </p>
      </section>

      <section>
        <h2>4. Gérer les cookies</h2>
        <p>
          Le Service ne déposant que des cookies strictement nécessaires, leur désactivation
          empêcherait l'utilisation du Service. Si vous souhaitez néanmoins les supprimer, vous
          pouvez le faire via les paramètres de votre navigateur (sections « Confidentialité » ou «
          Cookies »). La déconnexion via le bouton dédié du Service supprime également le cookie de
          session.
        </p>
      </section>

      <section>
        <h2>5. Contact</h2>
        <p>
          Pour toute question sur la présente politique de cookies, contactez{' '}
          <a href={`mailto:${LEGAL_INFO.dpoEmail}`}>{LEGAL_INFO.dpoEmail}</a>.
        </p>
      </section>
    </LegalLayout>
  );
}
